<template>
	<VueHtml2pdf
		ref="html2Pdf"
		:show-layout="false"
		:float-layout="true"
		:enable-download="false"
		:preview-modal="true"
		:paginate-elements-by-height="1400"
		:filename="filename"
		:pdf-quality="2"
		:manual-pagination="false"
		:html-to-pdf-options="options"
		@beforeDownload="beforeDownload($event)"
	>
		<template slot="pdf-content">
			<v-app>
				<div class="mx-8 mt-8">
					<v-avatar size="48px">
						<img :src="logo"></img>
					</v-avatar>
					<span class="ml-4 text-h4">{{ logoTitle }}</span>

					<h2 class="text-center">{{ title }}</h2>

					<v-row no-gutters>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
							№ {{ id }}
						</v-col>
						<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="text-right">
							{{ item.datecreate | formatDateTime }}
						</v-col>
						<v-col cols="12" class="text-right">
							{{ username }}
						</v-col>
					</v-row>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" v-if="parameters.length">
					<div class="text-subtitle-1 font-weight-bold">Параметри</div>
					<v-simple-table dense>
						<template v-slot:default>
							<tbody>
								<tr v-for="(item, index) in parameters" :key="index">
									<td width="50%">{{ item.name }}</td>
									<td>{{ item.value }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<v-divider class="mx-8"></v-divider>

				<div class="mx-8 my-6" flat v-for="(estimate, index) in estimates" :key="index">
					
					<div class="text-subtitle-1 font-weight-bold">Статистика</div>
					
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th width="50%"></th>
									<th class="font-weight-bold">USD</th>
									<th class="font-weight-bold">UAH</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Мінімальна ціна</td>
									<td>{{ minUSD(estimate.prices) | toMoney }}</td>
									<td>{{ minUAH(estimate.prices) | toMoney }}</td>
								</tr>
								<tr>
									<td>Максимальна ціна</td>
									<td>{{ maxUSD(estimate.prices) | toMoney }}</td>
									<td>{{ maxUAH(estimate.prices) | toMoney }}</td>
								</tr>
								<tr>
									<td>Середня ціна</td>
									<td>{{ avgUSD(estimate.prices) | toMoney }}</td>
									<td>{{ avgUAH(estimate.prices) | toMoney }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>

					<br>

					<div class="text-subtitle-1 font-weight-bold">За періодами</div>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th class="font-weight-bold" width="50%">Період</th>
									<th class="font-weight-bold">USD</th>
									<th class="font-weight-bold">UAH</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in estimate.prices" :key="index">
									<td>{{ item.name }}</td>
									<td>{{ item.priceUSD | toMoney }}</td>
									<td>{{ item.priceUAH | toMoney }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<v-divider class="mx-8"></v-divider>

				<section class="pdf-item" v-if="increas.length || reduce.length || elements.length">
					<div class="mx-8" v-if="increas.length">
						<br>
						<div class="text-subtitle-2 font-weight-bold">Фактори, що впливають на процент збільшення вартості КТЗ</div>
						<v-simple-table dense>
							<template v-slot:default>
								<thead>
									<tr>
										<th width="80%" class="text-left">Найменування факторів, які визначають умови експлуатації</th>
										<th width="20%" class="text-left">Дз, %</th>
										<!-- <th width="30%" class="text-left">Опис</th> -->
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in increas" :key="index" >
										<td>{{ item.name }}</td>
										<td>{{ item.type.val }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</div>

					<div class="mx-8" v-if="reduce.length">
						<br>
						<div class="text-subtitle-2 font-weight-bold">Фактори, що впливають на процент зменшення вартості КТЗ</div>
						<v-simple-table dense>
							<template v-slot:default>
								<thead>
									<tr>
										<th width="80%" class="text-left">Найменування факторів, які визначають умови експлуатації</th>
										<th width="20%" class="text-left">Дз, %</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in reduce" :key="index" >
										<td>{{ item.name }}</td>
										<td>{{ item.type.val }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</div>

					<div class="mx-8" v-if="elements.length">
						<br>
						<div class="text-subtitle-2 font-weight-bold">Проценти додаткового зменшення вартості КТЗ з дефектами кузова, кабіни, рами</div>
						<v-simple-table dense>
							<template v-slot:default>
								<thead>
									<tr>
										<th width="80%" class="text-left">Найменування елементів, складових частин КТЗ</th>
										<th width="20%" class="text-left">Дз, %</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in elements" :key="index" >
										<td>{{ item.name }}</td>
										<td>{{ item.type.val }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</div>
				</section>

				<div class="mx-8" v-if="factors.length">
					<div class="html2pdf__page-break"></div>
					<br>
					<div class="text-subtitle-1 font-weight-bold">Розрахунок вартості</div>
					<div class="text-subtitle-2">На основі аналізу довідкових даних щодо даного транспортного засобу встановлені такі показники:</div>
					<v-simple-table dense>
						<template v-slot:default>
							<thead>
								<tr>
									<th width="50%" class="text-left">Показник</th>
									<th width="10%" class="text-left">Умовне позначення</th>
									<th width="10%" class="text-left">Значення</th>
									<th width="30%" class="text-left">Опис</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in factors" :key="item.id" >
									<td>{{ item.name }}</td>
									<td>{{ item.code }}</td>
									<td>{{ item.val }}</td>
									<td>{{ item.description }}</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>

				<div class="mx-8" v-if="item.hasOwnProperty('costAmvUAH')">
					<br>
					<div class="text-subtitle-1 font-weight-bold">Висновок</div>
					<v-simple-table>
						<template v-slot:default>
							<tbody>
								<tr>
									<td width="70%">Середньоринкова вартість ТЗ становить:</td>
									<td class="d-flex justify-end align-center">{{ item.costAmvUAH }} грн.</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</div>
			</v-app>
		</template>
	</VueHtml2pdf>
</template>

<script>
import mixin from './mixin/main'
import VueHtml2pdf from 'vue-html2pdf' //https://www.npmjs.com/package/vue-html2pdf

export default {
	mixins: [mixin],
	components: { VueHtml2pdf },
	data: () => ({
		
	}),
	computed: {
		// Фактори, що впливають на процент збільшення вартості КТЗ
		increas() {
			//return this.item.hasOwnProperty('increas') ? this.item.increas: [];
			return this.item.hasOwnProperty('uses') ? this.item.uses.filter((item) => item.type.growing && !item.type.element ): [];
		},

		// Фактори, що впливають на процент зниження вартості КТЗ
		reduce() {
			//return this.item.hasOwnProperty('reduce') ? this.item.reduce: [];
			return this.item.hasOwnProperty('uses') ? this.item.uses.filter((item) => !item.type.growing && !item.type.element ): [];
		},

		// Проценти додаткового зменшення вартості КТЗ з дефектами кузова, кабіни, рами
		elements() {
			//return this.item.hasOwnProperty('elements') ? this.item.elements: [];
			return this.item.hasOwnProperty('uses') ? this.item.uses.filter((item) => !item.type.growing && item.type.element ): [];
		},

		factors() {
			return this.item?.factors ? this.item.factors: [];
		},
	},
	methods: {
		labels(items) {
			return items.map(element=>element.name);
		},

		valueUAH(items) {
			return items.map(element=>element.priceUAH);
		},

		valueUSD(items) {
			return items.map(element=>element.priceUSD);
		},

		avgUAH(items) {
			const arr = this.valueUAH(items);
			const average = arr.reduce((a, b) => a + b, 0) / arr.length;
			return average
		},

		avgUSD(items) {
			const arr = this.valueUSD(items);
			const average = arr.reduce((a, b) => a + b, 0) / arr.length;
			return average
		},

		minUAH(items) {
			const arr = this.valueUAH(items);
			return Math.min(...arr)
		},
		minUSD(items) {
			const arr = this.valueUSD(items);
			return Math.min(...arr)
		},

		maxUAH(items) {
			const arr = this.valueUAH(items);
			return Math.max(...arr)
		},
		maxUSD(items) {
			const arr = this.valueUSD(items);
			return Math.max(...arr)
		},
	},
}

</script>